"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
// import { materialColors as colors } from '../../themes';
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {},
        chipContainer: {
            display: 'flex',
            gap: 8,
            flexWrap: 'wrap',
        },
        fileChip: {
            cursor: 'pointer',
            flexBasis: 300,
            flexShrink: 1,
        },
        slider: {
            '& .swiper-container': {
                width: '100%',
                height: '100%',
                padding: '24px 0',
            },
            '& .swiper-button-next::after, & .swiper-button-prev::after': {
                color: '#fff',
                borderRadius: '3px',
                padding: theme.spacing(1),
                backgroundColor: 'rgba(0,0,0,.5)',
            },
            '& .swiper-slide': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            },
        },
    });
});
